import { Role } from '../../interfaces/Role';
import { WorkItemRoleHours } from '../../interfaces/WorkItemRoleHours';

export const getBudgetLeft = (
  workItemRoleHours: WorkItemRoleHours[],
  roles: Role[]
): number =>
  workItemRoleHours?.reduce((prev, workItemRoleHour) => {
    const foundRole = roles?.find(
      (role) => workItemRoleHour.role.id === role.id
    );
    if (foundRole) {
      prev =
        prev +
        ((workItemRoleHour.plannedHours || 0) -
          (workItemRoleHour.actualHours || 0)) *
          foundRole.hourlyRate;
    }
    return prev;
  }, 0);
